import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { AlertCircle, X } from 'lucide-react';
import './RegistrationBanner.css';

const RegistrationBanner: React.FC = () => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Verificar si el usuario ha cerrado el aviso manualmente
        const isDismissed = localStorage.getItem(`dismiss_reg_banner_${user.uid}`);
        if (isDismissed) {
          setShow(false);
          setLoading(false);
          return;
        }

        // Si estamos en la página de inscripción, no mostrar el banner
        if (location.pathname === '/inscricao') {
          setShow(false);
          setLoading(false);
          return;
        }

        try {
          const docSnap = await getDoc(doc(db, 'participantes', user.uid));
          // Si no existe el documento o no tiene modalidad de asistencia, mostramos el banner
          if (!docSnap.exists() || !docSnap.data().attendanceMode) {
            setShow(true);
          } else {
            setShow(false);
          }
        } catch (err) {
          console.error("Erro ao verificar status de participante:", err);
        }
      } else {
        setShow(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [location.pathname]);

  const handleDismiss = () => {
    if (auth.currentUser) {
      localStorage.setItem(`dismiss_reg_banner_${auth.currentUser.uid}`, 'true');
    }
    setShow(false);
  };

  if (loading || !show) return null;

  return (
    <div className="registration-banner">
      <div className="container banner-content">
        <div className="banner-text">
          <AlertCircle size={20} className="banner-icon" />
          <p>
            Você ainda não completou sua inscrição para o evento. 
            <Link to="/inscricao" className="banner-link"> Clique aqui para preencher o formulário de participação.</Link>
          </p>
        </div>
        <button onClick={handleDismiss} className="btn-close-banner" title="Não mostrar novamente">
          <X size={18} />
          <span className="desktop-only">Não ver mais</span>
        </button>
      </div>
    </div>
  );
};

export default RegistrationBanner;
